import { render, staticRenderFns } from "./OutboxMessageListItem.vue?vue&type=template&id=06fbb2b5&scoped=true"
import script from "./OutboxMessageListItem.vue?vue&type=script&lang=js"
export * from "./OutboxMessageListItem.vue?vue&type=script&lang=js"
import style0 from "./OutboxMessageListItem.vue?vue&type=style&index=0&id=06fbb2b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fbb2b5",
  null
  
)

export default component.exports